import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen } from '@fortawesome/free-solid-svg-icons';
import { coverSrc } from '../../util/coverSrc';

// Renders a project's cover image with two layers of fallback:
//
//   1. ``coverSrc(value)`` normalises the URL string. Empty / null
//      returns "" so we render the placeholder up front instead of
//      a broken <img>.
//
//   2. ``onError`` flips ``failed`` true on a runtime load failure
//      (S3 403 from a non-public object, expired presigned link,
//      DNS error, CORS-blocked image) so we swap to the same
//      placeholder. Without this the dashboard / search / read
//      pages would render the browser's broken-image glyph for
//      every dead URL.
//
// ``referrerPolicy="no-referrer"`` is set because some S3 bucket
// configurations 403 image requests that include a Referer header
// (signed-only access policies). Stripping it makes the request
// look identical to a direct hit and the public-read ACL grants
// it.
//
// ``loading="lazy"`` keeps off-screen covers out of the initial
// network burst on dashboards / search lists.
const BookCover = ({
  src,
  alt = '',
  className = '',
  iconClassName = 'text-secondText text-lg',
}) => {
  const url = coverSrc(src);
  const [failed, setFailed] = useState(false);
  const showPlaceholder = !url || failed;

  if (showPlaceholder) {
    return (
      <div
        className={`bg-surfaceAlt flex items-center justify-center ${className}`}
        aria-hidden={alt ? undefined : true}
      >
        <FontAwesomeIcon icon={faBookOpen} className={iconClassName} />
      </div>
    );
  }

  return (
    <img
      src={url}
      alt={alt}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
      className={className}
    />
  );
};

export default BookCover;
